export default "__VITE_ASSET__2fb5f1a3__"